module.exports = __webpack_public_path__ + "static/media/YF98_1.c6af4190.jpg";